// @flow
import {
    GET_SEARCH_SKETCH_ORDERS_REQUEST,
    GET_SEARCH_SKETCH_ORDERS_SUCCESS,
    GET_SEARCH_SKETCH_ORDERS_FAILURE,
} from "../actions/actionTypes";
import { type SearchSketchOrder } from '../typeDefinitions/searchSketchOrder';
import { type SearchResult } from "../typeDefinitions/searchResult";

type State = {
    +isFetching: boolean,
    +sketchOrders: Array<SearchSketchOrder>,
    +totalResults: number,
    +totalPages: number,
    +currentPage: number,
};

type Action = {
    type: string,
    response: SearchResult,
};

const initState: State = {
    isFetching: false,
    sketchOrders: [],
    totalResults: 0,
    totalPages: 0,
    currentPage: 0,
};

const searchSketchOrdersReducer = (state: State = initState, action: Action): State => {
    switch (action.type) {
        case GET_SEARCH_SKETCH_ORDERS_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_SEARCH_SKETCH_ORDERS_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                sketchOrders: action.response.results,
                totalResults: action.response.totalResults,
                totalPages: action.response.totalPages,
                currentPage: action.response.currentPage,
            });
        case GET_SEARCH_SKETCH_ORDERS_FAILURE:
            return Object.assign({}, state, initState);
        default:
            return state;
    }
};

export default searchSketchOrdersReducer;
